import { getPwaWorkspaceByIdOrKey, PwaWorkspaceSettings } from './workspaces';

const resolveActivePwaWorkspaceKey = (): string => {
  if (typeof import.meta !== 'undefined' && import.meta.env) {
    if (import.meta.env.VITE_WORKSPACE_ID) return import.meta.env.VITE_WORKSPACE_ID;
    if (import.meta.env.VITE_WORKSPACE) return import.meta.env.VITE_WORKSPACE;
  }
  if (typeof window !== 'undefined' && window.localStorage) {
    const saved = localStorage.getItem('workspace_id');
    if (saved) return saved;
  }
  return 'workspace-1';
};

export const activePwaWorkspaceConfig: PwaWorkspaceSettings = getPwaWorkspaceByIdOrKey(
  resolveActivePwaWorkspaceKey()
);

export const getPwaWorkspaceConfig = (): PwaWorkspaceSettings => activePwaWorkspaceConfig;

export default getPwaWorkspaceConfig;
